window.profilePhotoApp = function (data = {}) {
    return {
        url: data.url || false,
        originalUrl: data.url || false,
        updatingProfilePhoto() {
            return this.url !== this.originalUrl;
        },
        onProfilePhotoChange(e) {
            let file = e.target.files[0];
            if (file) {
                let reader = new FileReader();

                reader.onload = (e) => this.url = e.target.result;
                reader.readAsDataURL(file);
            }
        },
        removeProfilePhoto() {
            this.url = this.originalUrl;
            this.$refs.profilePhoto.value = null;
        },
    };
};
